import { useSelector } from "react-redux";
import {
  useGetLotPrefixListDataQuery,
  useDeleteLotPrefixMutation,
  useUpdateLotPrefixTableHeadDataMutation,
} from "../../../store/queries/Master";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import { updateConfig } from "../../../store/slices/Master/CertificatePrefix/certificatePrefixSlice";
// import { updateConfig } from "../../../store/slices/Master/LotPrefix/lotPrefixSlice";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { approveCertificateData, getShopPrefixData } from "./api";
import { Button } from "@wac-ui-dashboard/wac_component_library";

const useLotPrefix = () => {
  let paginationOptions = [
    { label: "20 Per page", value: 20 },
    { label: "40 Per page", value: 40 },
    { label: "60 Per page", value: 60 },
  ];

  const dispatch = useDispatch();

  const { tableFields, showEditModal } = useSelector((state) => state.global);
  const certificatePrefixState = useSelector(
    (state) => state.certificatePrefix
  );
  const {
    data: certificatePrefixList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetLotPrefixListDataQuery({
    page_size: certificatePrefixState?.currentPageSize,
    page: certificatePrefixState?.currentPage,
    sort_by: certificatePrefixState?.sortBy,
    sort_order: certificatePrefixState?.sortOrder,
    start: certificatePrefixState?.startDate,
    end: certificatePrefixState?.endDate,
    search: certificatePrefixState?.search,
  });
  const [deleteCertificatePrefix] = useDeleteLotPrefixMutation();
  const [updateCertificatePrefixFields] =
    useUpdateLotPrefixTableHeadDataMutation();

  useEffect(() => {
    dispatch(
      globalUpdateConfig((state) => {
        state.tableFields = certificatePrefixList?.data?.fields;
      })
    );
    // eslint-disable-next-line
  }, [certificatePrefixList]);

  useEffect(() => {
    if (
      certificatePrefixState?.selectedCertificatePrefix &&
      certificatePrefixState?.isEdit
    ) {
      fillCertificatePrefixData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    certificatePrefixState?.isEdit,
    certificatePrefixState?.showAddCertificatePrefixModal,
  ]);
  useEffect(() => {
    if (certificatePrefixState.clearSelection) {
      dispatch(
        updateConfig((state) => {
          state.clearSelection = false;
        })
      );
    }
    // eslint-disable-next-line
  }, [certificatePrefixState.clearSelection]);

  const handleModalClick = () => {
    dispatch(
      updateConfig((state) => {
        state.lotPrefixData = [];
        state.showAddCertificatePrefixModal =
          !state.showAddCertificatePrefixModal;
        state.isEdit = false;
      })
    );
  };

  const handleApprove = (id) => {
    let data = {
      certificate_prefix_id: id,
    };
    approveCertificateData(data).then((response) => {
      if (response?.data?.status_code === 200) {
        toast.success("Approved");
        refetch();
      } else {
        toast.error("Something went wrong");
      }
    });
  };

  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className="pro-mb-0">{data[field]}</p>,
      prefix_order: (field, data) => (
        <ul>
          {data?.[field]?.map((value, index) => {
            return <li key={index}>{value}</li>;
          })}
        </ul>
      ),
      status: (_, data) =>
        data?.status === "Deleted" ? (
          <span className={"pro-badge badge-danger-outline"}>{"Deleted"}</span>
        ) : data?.status === "Active" ? (
          <span className={"pro-badge badge-success-outline"}>{"Active"}</span>
        ) : data?.status === "Pending" ? (
          certificatePrefixList?.data?.approve_permission ? (
            <Button
              className={"pro-btn-primary sm"}
              type="button"
              onClick={() => handleApprove(data?._id)}
            >
              {"Approve"}
            </Button>
          ) : (
            <span className={"pro-badge outline-warning"}>{"Pending"}</span>
          )
        ) : (
          data?.status
        ),
    };

    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };

  const handleDelete = () => {
    deleteCertificatePrefix(
      certificatePrefixState?.selectedCertificatePrefix
    ).then((response) => {
      if (response?.data?.status_code === 200) {
        toast.success("Certificate Prefix deleted successfully");
        handleDeleteModal();
        refetch();
      } else if (response?.error?.data?.status_code === 422) {
        toast.error(response?.error?.data?.message ?? "Something went wrong");
        handleDeleteModal();
      } else {
        toast.error("Something went wrong");
        handleDeleteModal();
      }
    });
  };

  const fillCertificatePrefixData = () => {
    getShopPrefixData(
      certificatePrefixState?.selectedCertificatePrefix
    ).then((response) => {
      if (response?.data?.status_code === 200) {
        dispatch(
          updateConfig(
            (state) => (state.lotPrefixData = response?.data?.data)
          )
        );
      } else {
        toast.error("Something went wrong to fetch brach data");
      }
    });
  };

  const handleDeleteModal = (e) => {
    dispatch(
      updateConfig((state) => {
        state.showDeleteModal = !state.showDeleteModal;
        state.selectedCertificatePrefix = e?.[0];
      })
    );
  };

  const handleEditAction = (e) => {
    dispatch(
      updateConfig((state) => {
        state.lotPrefixData = [];
        state.showAddCertificatePrefixModal = true;
        state.selectedCertificatePrefix = e?.[0];
        state.isEdit = true;
      })
    );
  };

  const handleSearch = (e) => {
    dispatch(
      updateConfig((state) => {
        state.search = e.target.value;
        state.currentPage = 1;
      })
    );
  };

  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };

  const handleClearClick = () => {
    dispatch(updateConfig((state) => (state.search = "")));
  };

  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageSize = page_size;
        state.currentPage = 1;
      })
    );
  };
  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentPage = page;
      })
    );
  };

  const handleSort = (label) => {
    if (certificatePrefixState.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortOrder =
            certificatePrefixState.sortOrder === "asc" ? "desc" : "asc";
        })
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortBy = label;
          state.sortOrder = "asc";
        })
      );
    }
  };
  return {
    certificatePrefixState,
    showEditModal,
    tableFields,
    certificatePrefixList,
    isLoading,
    isFetching,
    paginationOptions,
    getRow,
    handleEditColumnsClick,
    handleSort,
    handlePagination,
    handleModalClick,
    handleDelete,
    handleDeleteModal,
    handleEditAction,
    handleSearch,
    handleClearClick,
    handlePageSize,
    refetch,
    updateCertificatePrefixFields,
  };
};

export default useLotPrefix;
